<div class="mb-3 clearfix">
  <div class="pull-let wd-md">
    <input [(ngModel)]="filterColumnText" placeholder="Filter all columns" class="form-control"
           (keyup)='updateFilter($event)'/>
  </div>
</div>
<div class="card card-default">
  <div class="card-body" [hidden]="!showTable()">
    <div class="table-responsive">
      <table #assignedFunctionTable class="table table-striped table-sm table-bordered">
        <thead>
        <tr>
          <th scope="col">
            <div class="checkbox c-checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="isCheckAll" (change)="selectAll()"/>
                <span class="fa fa-check"></span>
              </label>
            </div>
          </th>
          <th filterable="functionCategoryName" scope="col">Category</th>
          <th filterable="functionName" scope="col">Name</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let pageContentFunction of rows">
          <td scope="row">
            <div class="checkbox c-checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="pageContentFunction.isChecked"/>
                <span class="fa fa-check"></span>
              </label>
            </div>
          </td>
          <td>{{pageContentFunction.categoryName}}</td>
          <td>{{pageContentFunction.functionName}}</td>
          <td>
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-xs btn-warning" (click)="removeFunction(pageContentFunction)">
                Delete
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <br/>
    <div class="text-right">
      <pagination *ngIf="paginationEnabled" class="pagination-sm" [(ngModel)]="page" [totalItems]="length"
                  [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
                  (pageChanged)="onChangeTable($event)" (numPages)="numPages = $event">
      </pagination>
    </div>
  </div>
  <div class="card-body" *ngIf="!showTable()">
    No function added yet.
  </div>
  <div class="card-footer">
    <div class="row">
      <div class="col-8">
        <button class="btn btn-labeled btn-info mb-2" type="button" [disabled]="!showRemoveSelectedButton()"
                (click)="removeSelectedFunctions()">
          <span class="btn-label">
            <i class="fa fa-remove"></i>
          </span>Remove Selected
        </button>
        &nbsp;
        <button class="btn btn-labeled btn-info mb-2" type="button" (click)="addFunction()">
          <span class="btn-label">
            <i class="fa fa-plus"></i>
          </span>Add Function
        </button>
      </div>
      <div class="col-4" style="text-align: right;">
        <span class="text-danger" *ngIf="getSelectedCountText() != null">
          {{ getSelectedCountText() }}
          <a class="text-danger" href="#" (click)="unSelectAll($event)"> <i class="fa fa-close"></i></a>
        </span>
      </div>
    </div>
  </div>
</div>
<ngx-smart-modal #selectFunction identifier="selectFunction" customClass='msg-modal'>
  <app-function-select #functionSelectComponent (functionsAdded)="onFunctionsAdded($event)"
                       (closeModalClicked)="selectFunction.close()">
  </app-function-select>
</ngx-smart-modal>
